import { branch, renderNothing } from 'recompose'

import { locationSelector } from 'sfproxy/selectors'
import { canBuySelector } from '../selectors'
import BuyButtonCTA from 'map/components/actionButton/BuyButtonCTA'
import { buyLabelTranslationSelector, bookingUrlSelector } from 'map/selectors'
import { RateCurrency } from 'shared/price-utilities'

const Prices = ({ canBuy, buyLabel, location: { prices, currency, bookingUrl, opngo, externalSeasonTicketUrl } }) => (
    <div className="card blue">
        <div className="card-header">
            <h3>
                <T>label.park.drive.in.rate</T>
            </h3>
            <hr />
        </div>
        <div className="card-block">
            {prices.map(({ duration, price }, i) => (
                <div className="row" key={i}>
                    <div className="col rate-type">
                        <span>{duration !== null ? duration : <T>label.park.rate.na</T>}</span>
                    </div>
                    <div className="col price">
                        <span>
                            {price !== null ? (
                                <RateCurrency value={price} currency={currency} />
                            ) : (
                                <T>label.park.rate.na</T>
                            )}
                        </span>
                    </div>
                </div>
            ))}
        </div>
        {opngo && (
            <div className="card-footer">
                <BuyButtonCTA
                    canBuy={canBuy}
                    bookingUrl={bookingUrl}
                    buyLabel={buyLabel}
                    opngo={opngo}
                    externalSeasonTicketUrl={externalSeasonTicketUrl}
                />
            </div>
        )}
    </div>
)

export default compose(
    connect(
        createStructuredSelector({
            location: locationSelector,
            buyLabel: buyLabelTranslationSelector,
            canBuy: canBuySelector,
            bookingUrl: bookingUrlSelector,
        })
    ),
    branch(({ location: { prices } }) => !prices || prices.length === 0, renderNothing)
)(Prices)
